/**
 * Ile editów kupuje premia startowa — LICZBA Z KODU, nie z artboardu.
 *
 * Strona główna, FAQ i blok akcji mówią „Bez karty · 5 editów gratis”. Piątka na
 * artboardzie jest rysunkiem; jedyne miejsce, w którym ta liczba istnieje naprawdę,
 * to `app/billing/costs.py`:
 *
 *     SIGNUP_BONUS_GEMS = 15        # premia startowa (SPEC A5, LOCKED 2026-08-28)
 *     GEM_COST["render"] = 3        # koszt jednej generacji editu
 *
 * 15 / 3 = 5, więc rysunek i kod mówią dziś to samo — ale mówią to z dwóch różnych
 * miejsc, a to jest dokładnie ten układ, w którym jedna zmiana backendu zostawia na
 * stronie sprzedażowej nieprawdziwą obietnicę. Dlatego liczba jest TU wyliczana, a
 * `__tests__/start-bonus-matches-backend.test.ts` czyta oba literały prosto z pliku
 * Pythona i nie pozwala im się rozejść.
 *
 * Czemu nie z API: żaden endpoint nie podaje premii startowej (`/api/billing/plans`
 * niesie `gem_costs`, nie bonus), a mikrotekst stoi także w miejscach, które nie
 * czekają na odpowiedź sieci — w przyklejonym pasku akcji na 390 i na końcu FAQ.
 * Stała czytana z tego samego pliku co backend jest uczciwsza niż liczba wpisana
 * w zdanie.
 */
import { editsFromGems } from './gems'

/** `SIGNUP_BONUS_GEMS` z `app/billing/costs.py`. */
export const SIGNUP_BONUS_GEMS = 15

/** `GEM_COST["render"]` z `app/billing/costs.py`. */
export const RENDER_COST_GEMS = 3

/**
 * Edity, które premia startowa opłaca w całości.
 *
 * `editsFromGems` zaokrągla w dół i zwraca `null` przy niemożliwej cenie — tutaj
 * oba literały są dodatnie, więc `?? 0` jest tylko domknięciem typu.
 */
export const FREE_START_EDITS = editsFromGems(SIGNUP_BONUS_GEMS, RENDER_COST_GEMS) ?? 0
